import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const InvestorContext = createContext(defaultState);

export default InvestorContext;
